module.exports = __webpack_public_path__ + "img/logo.e6ac94e2.png";